/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HealthStatusEnum } from '../models/HealthStatusEnum';
import { HorseProfilePhotoRequest } from '../models/HorseProfilePhotoRequest';
import { SexEnumEnum } from '../models/SexEnumEnum';
import { HttpFile } from '../http/http';

export class SimpleHorseRequest {
    'faedingarnumer': string;
    'name': string;
    'sexEnum'?: SexEnumEnum;
    'healthStatus'?: HealthStatusEnum;
    'sportfengurId'?: number;
    'avatar'?: HorseProfilePhotoRequest;
    'colorCode'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "faedingarnumer",
            "baseName": "faedingarnumer",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "sexEnum",
            "baseName": "sexEnum",
            "type": "SexEnumEnum",
            "format": ""
        },
        {
            "name": "healthStatus",
            "baseName": "healthStatus",
            "type": "HealthStatusEnum",
            "format": ""
        },
        {
            "name": "sportfengurId",
            "baseName": "sportfengurId",
            "type": "number",
            "format": ""
        },
        {
            "name": "avatar",
            "baseName": "avatar",
            "type": "HorseProfilePhotoRequest",
            "format": ""
        },
        {
            "name": "colorCode",
            "baseName": "colorCode",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return SimpleHorseRequest.attributeTypeMap;
    }

    public constructor() {
    }
}



